export var OfficeSortColumn;
(function (OfficeSortColumn) {
    OfficeSortColumn["INDEX"] = "#";
    OfficeSortColumn["ADMIN"] = "Admin";
    OfficeSortColumn["EMAIL"] = "E-Mail";
    OfficeSortColumn["OFFICE_NAME"] = "Praxisname";
    OfficeSortColumn["REGISTERED_AT"] = "Registriert seit";
    OfficeSortColumn["VIDEO_THERAPY_ENABLED"] = "VIDEO_THERAPY_ENABLED";
    OfficeSortColumn["VIDEO_GALLERY_ENABLED"] = "VIDEO_GALLERY_ENABLED";
})(OfficeSortColumn || (OfficeSortColumn = {}));
//# sourceMappingURL=office-sort-colums.enum.js.map